const RAPTIVE_SITE_ID = "64f8b60778b84a08902d456d";

// Raptive (formerly AdThrive) ads, loaded through @nuxt/scripts.
// The loader still starts during app start, as before; delaying it (e.g. `trigger: "onNuxtReady"`) would help LCP and
// TBT but changes viewability and revenue, so check with Raptive first (see docs/performance.md).
export default defineNuxtPlugin(() => {
  // disable ads on localhost and cloudflare preview branch deploy
  if (import.meta.dev || window.location.hostname.endsWith("pages.dev")) {
    return;
  }

  window.adthrive = window.adthrive || {};
  window.adthrive.cmd = window.adthrive.cmd || [];
  window.adthrive.plugin = "adthrive-ads-manual-spa";
  window.adthrive.host = "ads.adthrive.com";

  useScript(
    {
      key: "raptive",
      src: `https://${window.adthrive.host}/sites/${RAPTIVE_SITE_ID}/ads.min.js?referrer=${encodeURIComponent(window.location.href)}`,
      async: true,
      referrerpolicy: "no-referrer-when-downgrade",
    },
    // warmupStrategy false: otherwise @nuxt/scripts preloads ads.min.js at page start even though it runs later
    { trigger: "client", warmupStrategy: false },
  );

  loadAdBlockerRecovery();
});

// Raptive's ad-blocker recovery: npttech.com/advertising.js is fetched and run inline so blockers that match script
// URLs don't stop it. If it can't be fetched, an `__adblocker=true` cookie is set for 5 minutes, and while that cookie
// is set Raptive's gallery video player is loaded instead.
function loadAdBlockerRecovery() {
  if (!document.cookie.includes("__adblocker")) {
    document.cookie = "__adblocker=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    const request = new XMLHttpRequest();
    request.open("GET", "https://www.npttech.com/advertising.js", true);
    request.onreadystatechange = () => {
      if (request.readyState !== XMLHttpRequest.DONE) return;
      if (request.status === 200) {
        const script = document.createElement("script");
        script.innerHTML = request.responseText;
        document.head.appendChild(script);
      } else {
        const expires = new Date(Date.now() + 5 * 60 * 1000);
        document.cookie = `__adblocker=true; expires=${expires.toUTCString()}; path=/`;
      }
    };
    request.send();
  }

  const galleryPlayer = useScript(
    { key: "raptive-gallery-player", src: "https://cafemedia-com.videoplayerhub.com/galleryplayer.js" },
    { trigger: "manual" },
  );
  const adBlockerCookie = () => document.cookie.match("(^|[^;]+)\\s*__adblocker\\s*=\\s*([^;]+)")?.pop();

  if (adBlockerCookie() === "true") {
    galleryPlayer.load();
    return;
  }
  // otherwise poll the cookie every 50 ms, for up to 5 s, until the recovery check above has an answer
  let checks = 0;
  const poll = setInterval(() => {
    const value = adBlockerCookie();
    if (value === "true") galleryPlayer.load();
    if (value === "true" || value === "false" || ++checks >= 100) clearInterval(poll);
  }, 50);
}
